import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { TopBar } from './TopBar'
import { LeftRail } from './LeftRail'
import { FailedSavesBanner } from './FailedSavesBanner'
import { SavedToast } from './SavedToast'
import { ServiceStatusBanner } from './ServiceStatusBanner'

export function AppShell() {
  const [navOpen, setNavOpen] = useState(false)
  return (
    <div className="app">
      <ServiceStatusBanner />
      <TopBar onToggleNav={() => setNavOpen((o) => !o)} />
      <LeftRail open={navOpen} onClose={() => setNavOpen(false)} />
      {navOpen && <div className="rail-scrim" onClick={() => setNavOpen(false)} />}
      <main className="app-main">
        <div className="app-main-inner">
          <Outlet />
        </div>
      </main>
      <FailedSavesBanner />
      <SavedToast />
    </div>
  )
}
